import React, { Suspense } from 'react';
import { lazy } from 'react';
import { Box } from '@mui/material';
import ContainerSpinner from 'src/ui-components/ContainerSpinner';

// Lazy load the talent component
const TalentView = lazy(() => import('./talent'));

const SingleEventPage: React.FC = () => {
  return (
    <Box>
      <Suspense fallback={<ContainerSpinner height="400px" />}>
        <TalentView />
      </Suspense>
    </Box>
  );
};

export default SingleEventPage;

